import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import "./index.less";

export function Popup({ title, extClass = "", children, footer, onBack }) {
  return (
    <div className={`buydeal-popup ${extClass}`} data-animate="fadeIn">
      <div className="buydeal-popup-header">
        <i
          className="icon icon-arrow-left"
          onClick={() => {
            onBack && onBack();
          }}
        ></i>
        <strong>{title}</strong>
        <span></span>
      </div>
      <div className="buydeal-popup-line"></div>
      <div className="buydeal-popup-body">{children}</div>
      <div className="buydeal-popup-footer">{footer}</div>
    </div>
  );
}

/**
 * 列表组件
 * @param {Array} list
 * @returns
 */
export function List({ list }) {
  return (
    <div className="buydeal-list">
      {list.map((item, index) => {
        return <ListItem key={index} {...item}></ListItem>;
      })}
    </div>
  );
}

/**
 * 列表项组件
 * @param {*} param0
 * @returns
 */
export function ListItem({ icon, title, value, onClick, hidden, mark }) {
  if (hidden) return null;
  return (
    <div className={`buydeal-list-item ${mark ? "mark-amount" : ""}`}>
      <div className="buydeal-list-item-left">
        {icon ? (
          <img src={icon} alt="" className="buydeal-list-item-icon" />
        ) : null}
        {title ? (
          <span className="buydeal-list-item-title">{title}</span>
        ) : null}
      </div>
      <div
        className="buydeal-list-item-right"
        onClick={onClick || function () {}}
      >
        {value}
      </div>
    </div>
  );
}

/**
 * 弹窗
 * @param {*} param0
 * @returns
 */
export function Modal({ title, children, onClose }) {
  const [hide, setHide] = useState(false);
  const { t } = useTranslation();
  function onClick() {
    setHide(true);
    setTimeout(() => {
      onClose();
    }, 260);
  }
  return (
    <div className="buydeal-modal" hidden={hide}>
      <div className="buydeal-modal-mask" hidden={hide} onClick={onClick}></div>
      <div className="buydeal-modal-body" hidden={hide}>
        <div className="buydeal-modal-title">{title}</div>
        <div className="buydeal-modal-content">{children}</div>
        <div className="buydeal-modal-foot">
          <div className="buydeal-modal-btn" onClick={onClick}>
            {t("VOUCHERS.Close")}
          </div>
        </div>
      </div>
    </div>
  );
}

/**
 * 确认弹窗
 * @param {*} param0
 * @returns
 */
export const ConfirmModal = ({ children, onCancel, onOk }) => {
  const { t } = useTranslation();
  return (
    <div className="buydeal-confirm-modal">
      <div className="buydeal-modal-mask"></div>
      <div className="buydeal-modal-body">
        <div className="buydeal-modal-content">{children}</div>
        <div className="buydeal-modal-foot">
          <div
            className="buydeal-modal-btn"
            onClick={onCancel || function () {}}
          >
            {t("BACK")}
          </div>
          <div
            className="buydeal-modal-btn primary"
            onClick={onOk || function () {}}
          >
            {t("YES_OPTION")}
          </div>
        </div>
      </div>
    </div>
  );
};
